module.exports = __webpack_public_path__ + "static/media/AccountInfo.5583d38d.svg";